import React from 'react'
import GameModeConfigSeparator from './GameModeConfigSeparator';
import { FaUser, FaUsers } from 'react-icons/fa';
import TooltipFFXIV from '@/app/components/TooltipFFXIV';
import { useTranslation } from '@/hooks/useTranslation';
import { useGame } from '@/app/providers/GameContextProvider';
import { getGameModeByType } from '@/lib/types/common/GameModeAdvancedSettings';
import { GameMode } from '@/lib/types/common/GameMode';
import TextFFXIV from '@/app/components/TextFFXIV';
import Image from 'next/image';
import { useDeviceInfo } from '@/hooks/useIsMobile';

const GameModeConfigDescription = () => {
    const { t } = useTranslation();
    const { gameState } = useGame();
    const { isMobile } = useDeviceInfo();

    // Get the currently selected game mode from game state
    const selectedGameMode = gameState?.gameMode || GameMode.TIMED;
    const gameModeConfig = getGameModeByType(selectedGameMode);

    if (!gameModeConfig) {
        return null; // Handle case where game mode config is not found
    }

    return (
        <>
            {!isMobile && (
                <>
                    <div className="flex gap-2 items-center justify-between w-full">
                        <div className="flex gap-2 items-center">
                            {/* Icon with shadow */}
                            <div
                                className="relative w-9 h-9 flex items-center justify-center rounded-lg shadow-black/50 shadow-md overflow-hidden"
                                style={{
                                    background: 'radial-gradient(circle, #4A1818 0%, #AC3939 100%)'
                                }}
                            >
                                {/* Top highlight */}
                                <div className="absolute top-0 left-0 w-full h-full rounded-lg pointer-events-none z-20 border-t-[1px] border-[#EFE9E0] opacity-70"></div>
                                {/* Bottom highlight */}
                                <div className="absolute top-0 left-0 w-full h-full rounded-lg pointer-events-none z-20 border-b-[1px] border-[#EFE9E0] opacity-20"></div>
                                {/* White top glow */}
                                <div className="top-0 -translate-y-1/2 absolute w-[130%] h-[30px] bg-gradient-to-b from-white/80 to-transparent rounded-[60%]"></div>

                                <Image
                                    src={`/game_modes/${selectedGameMode}.png`}
                                    width={64}
                                    height={64}
                                    alt={t(`game.modes.${selectedGameMode}.name`)}
                                />
                            </div>
                            <TextFFXIV text={t(`game.modes.${selectedGameMode}.name`)} className="text-2xl" />
                        </div>
                        <div className="relative flex items-center gap-5 mr-1">
                            {gameModeConfig.minPlayers === 1 && (
                                <div className="group relative">
                                    <TooltipFFXIV>{t('game.players.solo')}</TooltipFFXIV>
                                    <FaUser className="text-xl" />
                                </div>
                            )}
                            {gameModeConfig.maxPlayers > 1 && (
                                <div className="group relative">
                                    <TooltipFFXIV>{t('game.players.multiplayer')}</TooltipFFXIV>
                                    <FaUsers className="text-xl scale-150" />
                                </div>
                            )}
                        </div>
                    </div>
                    <GameModeConfigSeparator />
                </>
            )}
            <div className="text-shadow-border shadow-black">{t(`game.modes.${selectedGameMode}.description`)}</div>
        </>
    )
}

export default GameModeConfigDescription